import { useCallback } from "react"
import { Box, Button, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { useNavigate } from "react-router-dom"

import { APP_STATUS, updateAppStatus } from "utils/electron"

import { useHome } from "hooks/home/useHome"
import { useTranslation } from "providers/i18n"

import { AppNavigation as DefaultAppNavigation } from "containers/kiosk-h"
import { PageCard } from "components/card"
import { NearMeIcon } from "components/icons"
import { SidebarMenu } from "extensions/iconsiam/components/navigation/kiosk-h/SidebarMenu"
import { ContentWithAside } from "layouts/kiosk-h"
import { formbricksTrack } from "extensions/iconsiam/utils"
import { HomeGuideCards } from "./HomeGuideCards"
import { useHomeMap } from "hooks/home/useHomeMap"
import { useHomeInstructionCards } from "extensions/iconsiam/hooks/home-instruction-cards/useHomeInstructionCards"

export const HomeWithScreenSaverInfosPage = ({
  Layout = ContentWithAside,
  AppNavigation = DefaultAppNavigation,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { venues, defaultRoutePath } = useHome()
  const { enable: instructionCardsEnable } = useHomeInstructionCards()

  useHomeMap(venues)

  const base = theme.components?.[`HomePage`]?.styleOverrides ?? {}
  const infos =
    theme.components?.[`HomeWithScreenSaverInfosPage`]?.styleOverrides ?? {}
  const {
    pageCard,
    contentContainer,
    infoPanel,
    actionContainer,
    actionButton,
    welcomeContainer,
    touchToStartText,
    touchToStartIcon,
    guideCards,
    classicWelcomeContainer,
    classicActionButton,
    classicTouchToStartText,
  } = deepmerge(base, infos)

  const handleClick = useCallback(() => {
    formbricksTrack("touch_to_start_kiosk")
    updateAppStatus(APP_STATUS.ACTIVE)
    navigate(defaultRoutePath)
  }, [navigate, defaultRoutePath])

  return (
    <Layout
      aside={
        <PageCard>
          <SidebarMenu AppNavigation={AppNavigation} />
        </PageCard>
      }
    >
      <PageCard sx={pageCard}>
        <Box sx={contentContainer} className="contentContainer">
          <Box
            sx={{ ...infoPanel, cursor: "pointer" }}
            className="infoPanel"
            onClick={handleClick}
          >
            {instructionCardsEnable ? (
              <>
                <HomeGuideCards sx={guideCards} />
                <Box sx={welcomeContainer}>
                  <Box sx={actionContainer}>
                    <Button sx={actionButton}>
                      <Typography sx={touchToStartText}>
                        {t("START")}
                      </Typography>
                    </Button>
                  </Box>
                </Box>
              </>
            ) : (
              <Box sx={classicWelcomeContainer}>
                <Box sx={actionContainer}>
                  <Button sx={classicActionButton}>
                    <NearMeIcon sx={touchToStartIcon} />
                    <Typography sx={classicTouchToStartText}>
                      {t("Touch to start")}
                    </Typography>
                  </Button>
                </Box>
              </Box>
            )}
          </Box>
        </Box>
      </PageCard>
    </Layout>
  )
}
